export enum WidgetTableFilterMenuType {
    AlignedWithChildren,
    Expandable,
    WithSubMenu,
    FoldedSchedules,
    SingleSelectOption,
    MultiSelectOption,
}
